import { Link, Navigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { services } from '../data/services';

function ServiceDetail() {
  const { slug } = useParams();
  const service = services.find((item) => item.slug === slug);

  if (!service) return <Navigate to="/services" replace />;

  return (
    <>
      <section className="detail-hero">
        <img src={service.image} alt="" aria-hidden="true" />
        <div className="detail-shade" aria-hidden="true" />
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <span className="eyebrow">
            {service.number} / 08 — Our services
          </span>
          <h1>{service.title}</h1>
          <p>{service.short}</p>
        </motion.div>
      </section>

      <section className="detail-content">
        <div className="detail-intro">
          <span className="section-tag">What we deliver</span>
          <h2>
            Expert craft.
            <br />
            <em>Exceptional impact.</em>
          </h2>
        </div>
        <div className="deliverables">
          {service.services.map((item, index) => (
            <motion.div
              key={item}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <span aria-hidden="true">
                {String(index + 1).padStart(2, '0')}
              </span>
              <p>{item}</p>
              <SafeIcon
                name="Check"
                aria-hidden="true"
                focusable="false"
              />
            </motion.div>
          ))}
        </div>
      </section>

      <section className="next-project">
        <p>Ready to elevate your next project?</p>
        <Link to="/contact">
          Let's create together
          <SafeIcon
            name="ArrowRight"
            aria-hidden="true"
            focusable="false"
          />
        </Link>
      </section>
    </>
  );
}

export default ServiceDetail;